import firebaseApp from "../../firebase/credenciales";
import { getFirestore, collection, doc, setDoc } from "firebase/firestore";

function añadir_pago(infoProducto) {
  const db = getFirestore(firebaseApp);
  const collectionRef = collection(db, "Proveedores_pagos/"+infoProducto.nombre+"/Productos/");
  const docRef = doc(collectionRef, infoProducto.fecha);
  setDoc(docRef, infoProducto);      
}

export default añadir_pago;
